import React, { useState } from "react";
import { useSettings } from "hooks/useStore";
import Skeleton from "components/loader/product-gallery-skeleton";
import MainSwiper from "./main-swiper";
import ThumbnailSwiper from "./thumb-swiper";
import clsx from "clsx/lite";

const filterAndSortImages = (productImages, variantImages, customSort) => {
	const mainImages = customSort ? productImages.filter((image) => image._type !== "customImageNoUrl") : [];
	const { cylindoImages, otherVariantImages } = variantImages.reduce(
		(acc, image) => {
			if (image._type === "cylindo") {
				acc.cylindoImages.push(image);
			} else {
				acc.otherVariantImages.push(image);
			}
			return acc;
		},
		{ cylindoImages: [], otherVariantImages: [] }
	);

	const allImages = [...cylindoImages, ...mainImages, ...otherVariantImages, ...productImages];

	// Filter out duplicates based on image.asset._ref
	return allImages.filter((image, index, self) =>
		image._type === "cylindo" ||
		index === self.findIndex((t) => (
			t.asset && t.asset._ref === image.asset?._ref
		))
	);
};

const ProductGallery = ({
	title, productId, productImages = [], variantImages = [], percentageDiscount,
	customSort, className, verticalThumbsDesktop = false, showFiveSlides = false, hideCylindoDynaimcFeature = false }) => {

	const [thumbsSwiper, setThumbsSwiper] = useState(null);
	const { pageLoading } = useSettings(["pageLoading"]);

	const filteredImages = filterAndSortImages(productImages, variantImages, customSort);
	if (!filteredImages?.length) return null;

	const isFirstCylindo = filteredImages[0]._type === "cylindo";

	if (isFirstCylindo && pageLoading) {
		return <Skeleton verticalThumbsDesktop={verticalThumbsDesktop} />;
	}

	return (
		<div className={clsx(className, "overflow-hidden",
			verticalThumbsDesktop && "vertical-thumbs-desktop-container")}>
			<div className={clsx("relative", verticalThumbsDesktop && "vertical-thumbs-desktop-inner")}>
				<MainSwiper filteredImages={filteredImages} productId={productId}
					title={title} percentageDiscount={percentageDiscount} thumbsSwiper={thumbsSwiper}
					hideCylindoDynaimcFeature={hideCylindoDynaimcFeature}
				/>
			</div>
			<div className={clsx(verticalThumbsDesktop && "lg:w-24 xl:w-28  mr-auto overflow-hidden", "max-w-full",
				showFiveSlides ? "px-0" : "px-4 md:px-0")}>
				<ThumbnailSwiper filteredImages={filteredImages} setThumbsSwiper={setThumbsSwiper}
					verticalThumbsDesktop={verticalThumbsDesktop} title={title} showFiveSlides={showFiveSlides}
				/>
			</div>
		</div>
	);
};

export default ProductGallery;